import {
  createThemeProvider,
  themed,
  createVariants,
} from '@sail/engine/deprecated';

import {css} from './css';

export {css, view, unstable_media} from './css';

export const Provider = createThemeProvider([]);

// Concepts
export const focus = themed();
export const focusSibling = themed();
export const focusWithin = themed();
export const shadow = themed();
export const visuallyHidden = css({
  border: css.value('0'),
  clip: css.value('rect(0 0 0 0)'),
  clipPath: css.value('inset(50%)'),
  height: css.value('1px'),
  margin: css.value('0 -1px -1px 0'),
  overflow: css.value('hidden'),
  padding: 0,
  position: css.value('absolute'),
  width: css.value('1px'),
  whiteSpace: css.value('nowrap'),
});

// Components
export const AccordionItem = themed();
export const AccordionItemSubtitle = themed();
export const AccordionItemTitle = themed();
export const Backdrop = themed();
export const Badge = themed();
export const Breadcrumbs = themed();
export const BreadcrumbLink = themed();
export const Button = themed();
export const Counter = themed();
export const Checkbox = themed();
export const CheckboxIcon = themed();
export const CheckboxDisabledOverlay = themed();
export const Chip = themed();
export const ChipList = themed();
export const Divider = themed();
export const Drawer = themed();
export const DrawerConfirmationDialog = {
  container: themed(),
  heading: themed(),
  content: themed(),
  footer: themed(),
  wash: themed(),
};
export const Dialog = themed();
export const DialogCloseButton = themed();
export const DialogContent = themed();
export const DialogFooter = {
  container: themed(),
  leading: themed(),
};
export const DialogHeader = {
  container: themed(),
  title: themed(),
  subtitle: themed(),
};
export const FormFieldGroup = themed();
export const Icon = themed();
export const IconButton = themed();
export const CompositeField = themed();
export const Label = themed();
export const Link = themed();
export const List = {
  container: themed(),
  item: {
    container: themed(),
    title: themed(),
    secondaryTitle: themed(),
    image: themed(),
  },
};
export const Menu = themed();
export const MenuItem = themed();
export const MenuItemSeparator = themed();
export const MenuGroup = themed();
export const MenuGroupHeading = themed();
export const MenuGroupItems = themed();
// @deprecated
export const Notice = 'deprecated';
export const Banner = themed();
export const PhoneNumberFieldCountryCode = themed();
export const Popover = themed();
export const Radio = themed();
export const RadioOuter = themed();
export const RadioInner = themed();
export const RadioDisabledOverlay = themed();
export const Select = themed();
export const SelectArrows = themed();
export const SelectWrapper = themed();
export const Signpost = themed();
export const Switch = themed();
export const SwitchDisabledOverlay = themed();
export const Tab = themed();
export const TabDisabledOverlay = themed();
export const TabLine = themed();
export const TabList = themed();
export const Tag = themed();
export const TailorDateField = themed();
export const TailorDateFieldInput = themed();
export const TailorDateFieldSeparator = themed();
export const TailorDateFieldGroup = themed();
export const TextArea = themed();
export const TextField = themed();
export const TextFieldLabel = themed();
export const Tooltip = themed();

// Variants
// TODO: move these out of here when there is a better spot for them
// Would be nice to define in the component file, but would create a circular dep
export const ActionVariants = createVariants('Action', {
  disabled: {
    true: null,
    false: null,
  },
  pressed: {
    true: null,
    false: null,
  },
});

export const BadgeVariants = createVariants('Badge', {
  type: {
    urgent: null,
    warning: null,
    negative: null,
    positive: null,
    info: null,
    neutral: null,
  },
});

export const ButtonVariants = createVariants('Button', {
  size: {
    small: null,
    medium: null,
    large: null,
  },
  type: {
    primary: null,
    secondary: null,
    destructive: null,
  },
});

export const CheckboxVariants = createVariants('Checkbox', {
  indeterminate: {
    true: null,
    false: null,
  },
  invalid: {
    true: null,
    false: null,
  },
});

export const ChipVariants = createVariants('Chip', {
  variant: {
    active: null,
    value: null,
    suggested: null,
  },
  hasDropdown: {
    true: null,
    false: null,
  },
});

export const ChipListVariants = createVariants('ChipList', {
  direction: {
    row: null,
    'row-reverse': null,
  },
});

export const ChipIconButtonVariants = createVariants('ChipIconButton', {
  variant: {
    active: null,
    value: null,
    suggested: null,
    chevron: null,
  },
});

export const CounterVariants = createVariants('Counter', {
  type: {
    default: null,
    emphasized: null,
    micro: null,
  },
});

export const CurrencyFieldVariants = createVariants('CurrencyField', {
  disabled: {
    true: null,
    false: null,
  },
});

export const DrawerVariants = createVariants('Drawer', {
  inline: {
    true: null,
    false: null,
  },
  size: {
    small: null,
    medium: null,
    large: null,
  },
});

export const DialogVariants = createVariants('Dialog', {
  size: {
    small: null,
    medium: null,
    large: null,
    xlarge: null,
  },
});

export const CompositeFieldVariants = createVariants('CompositeField', {
  invalid: {
    true: null,
    false: null,
  },
  focus: {
    true: null,
    false: null,
  },
  size: {
    small: null,
    medium: null,
    large: null,
  },
  disabled: {
    true: null,
    false: null,
  },
});

export const FormFieldGroupVariants = createVariants('FormFieldGroup', {
  invalid: {
    true: null,
    false: null,
  },
});

export const IconVariants = createVariants('Icon', {
  size: {
    xxsmall: null,
    xsmall: null,
    small: null,
    medium: null,
    large: null,
    xlarge: null,
  },
});

export const LayerVariants = createVariants('Layer', {
  type: {
    overlay: null,
    partial: null,
    root: null,
  },
});

export const LinkVariants = createVariants('Link', {
  type: {
    primary: null,
    secondary: null,
  },
});

export const LabelVariants = createVariants('Label', {
  invalid: {
    true: null,
    false: null,
  },
  position: {
    top: null,
  },
});

export const ListItemVariants = createVariants('ListItem', {
  hasIcon: {
    true: null,
    false: null,
  },
  size: {
    default: null,
    large: null,
  },
  hasSecondaryTitle: {
    true: null,
    false: null,
  },
  hasAction: {
    true: null,
    false: null,
  },
});

// @deprecated
export const NoticeVariants = 'deprecated';

export const BannerVariants = createVariants('Banner', {
  type: {
    default: null,
    critical: null,
    caution: null,
  },
});

export const RadioVariants = createVariants('Radio', {
  invalid: {
    true: null,
    false: null,
  },
});

export const SelectVariants = createVariants('Select', {
  invalid: {
    true: null,
    false: null,
  },
  size: {
    small: null,
    medium: null,
    large: null,
  },
  isInCompositeField: {
    true: null,
    false: null,
  },
});

export const SelectWrapperVariants = createVariants('Select', {
  isInCompositeField: {
    true: null,
    false: null,
  },
});

export const MenuItemVariants = createVariants('MenuItem', {
  modality: {
    keyboard: null,
    pointer: null,
  },
  disabled: {
    true: null,
    false: true,
  },
  type: {
    default: null,
    destructive: null,
  },
});
export const PhoneNumberFieldCountryCodeVariants = createVariants(
  'PhoneNumberField',
  {
    size: {
      small: null,
      medium: null,
      large: null,
    },
  },
);
export const SignpostVariants = createVariants('Signpost', {
  color: {
    wave: null,
    blue: null,
    green: null,
    pink: null,
    purple: null,
    yellow: null,
  },
});

export const SwitchVariants = createVariants('Switch', {
  invalid: {
    true: null,
    false: null,
  },
});

export const TabVariants = createVariants('Tab', {
  size: {
    small: null,
    medium: null,
    large: null,
  },
  fitted: {
    true: null,
    false: null,
  },
  selected: {true: null, false: null},
  disabled: {true: null, false: null},
});

export const TabListVariants = createVariants('TabList', {
  fitted: {
    true: null,
    false: null,
  },
});

export const TagVariants = createVariants('Tag', {
  hasColor: {
    true: null,
    false: null,
  },
});

export const TailorDateFieldVariants = createVariants('TailorDateField', {
  invalid: {
    true: null,
    false: null,
  },
  disabled: {
    true: null,
    false: null,
  },
  size: {
    small: null,
    medium: null,
    large: null,
  },
});

export const TailorDateFieldInputVariants = createVariants(
  'TailorDateFieldInput',
  {
    dateType: {
      year: null,
      default: null,
    },
  },
);

export const TextAreaVariants = createVariants('TextField', {
  invalid: {
    true: null,
    false: null,
  },
  resizeable: {
    true: null,
    false: null,
  },
  size: {
    small: null,
    medium: null,
    large: null,
  },
});

export const TextFieldVariants = createVariants('TextField', {
  invalid: {
    true: null,
    false: null,
  },
  size: {
    small: null,
    medium: null,
    large: null,
  },
  isInCompositeField: {
    true: null,
    false: null,
  },
});

export const TextFieldLabelVariants = createVariants('TextFieldLabel', {
  position: {
    top: null,
  },
});

export const TooltipVariants = createVariants('Tooltip', {
  type: {
    description: null,
    label: null,
  },
  placement: {
    center: null,
    'top left': null,
    top: null,
    'top right': null,
    'right top': null,
    right: null,
    'right bottom': null,
    'bottom right': null,
    bottom: null,
    'bottom left': null,
    'left bottom': null,
    left: null,
    'left top': null,
  },
});
